import axios from 'axios';
import { getEnvironment } from '../../utils/Environment';
import { postIMSAppsDataToFetch } from 'cchome-apps';

class PostIMSFetchService {
	clientKeyServiceMap: any;
	keyResponseMap: any;

	constructor() {
		this.clientKeyServiceMap = {};
		this.keyResponseMap = {};
	}

	useNull(e) {
		console.log(e);
		return null;
	}

	hasFeature(feature: string) {
		return (
			window.cchome &&
			window.cchome.util &&
			window.cchome.util.hasFeature &&
			window.cchome.util.hasFeature(feature)
		);
	}

	getHeader(header) {
		const headers = { ...header };
		const imsToken = window.adobeIMS && window.adobeIMS.getAccessToken();
		if (imsToken && imsToken !== '') {
			headers.Authorization = `Bearer ${imsToken}`;
		}
		return headers;
	}

	getPromise(serviceObj) {
		let promise;
		if (serviceObj.type === 'url') {
			const { data, headers, url, method } = serviceObj;
			const options = {
				url,
				method: method ? method : 'get',
				data,
				headers: headers ? this.getHeader(headers) : undefined,
			};
			promise = axios({ ...options });
			if (!serviceObj.useCustomCatch) {
				promise = promise.catch(this.useNull);
			}
		} else if (serviceObj.type === 'promise') {
			promise = serviceObj.promise;
		}
		// Functionality to add a callback when promise resolves
		if (serviceObj.callback) {
			promise = promise.then((response) => {
				const { key, service } = serviceObj.callback(response);
				this.keyResponseMap[key] = this.getPromise(service);
				return response;
			});
		}
		return promise;
	}

	fetchData() {
		Object.entries(this.clientKeyServiceMap).forEach(([key, service]) => {
			this.keyResponseMap[key] = this.getPromise(service);
		});
	}

	registerServices(locale) {
		const path = window.location.pathname.split('/');
		if (!path[1]) {
			return;
		}
		switch (path[1].toLowerCase()) {
			case 'apps':
				this.clientKeyServiceMap = postIMSAppsDataToFetch(locale, getEnvironment());
				break;
			default:
				return;
		}
	}

	getResponseForKey = (key) => this.keyResponseMap[key];
}

export default new PostIMSFetchService();
